<lib-icon [iconConfig]="clearIcon" (onClicked)="onClick()"></lib-icon>
